import { createReducer, on } from '@ngrx/store';
import { OFFERS_INITIAL_STATE, OffersStore } from './offers.model';
import OFFERS_ACTIONS from './offers.actions';
import { OffersType } from '@toevla-webapplications/core';

const _offersReducer = createReducer<OffersStore>(
	OFFERS_INITIAL_STATE,

	on(OFFERS_ACTIONS.setFilters, (state, obj) => {
		return {
			...state,
			filters: {
				...state.filters,
				...obj.filters,
			},
		};
	}),
	on(OFFERS_ACTIONS.setLocations, (state, obj) => {
		return {
			...state,
			locations: obj.locations,
		};
	}),
	on(OFFERS_ACTIONS.setOrder, (state, obj) => {
		return {
			...state,
			data: OFFERS_INITIAL_STATE.data,
			order: {
				name: obj.name,
				asc: obj.asc,
				sort: obj.sort,
			},
		};
	}),
	on(OFFERS_ACTIONS.setType, (state, obj) => {
		let order = state.order;

		if (obj.t === OffersType.ORGANIZED_HOLIDAY && order.sort === 'price') {
			order = {
				name: 'ALPHABETICALLY_ASC',
				asc: true,
				sort: 'name',
			};
		}

		return {
			...state,
			type: obj.t,
			data: OFFERS_INITIAL_STATE.data,
			filters: OFFERS_INITIAL_STATE.filters,
			order,
		};
	}),
	on(OFFERS_ACTIONS.clearSideFilters, (state, obj) => {
		const mainFilters: any = {};

		if (state.type === OffersType.ORGANIZED_HOLIDAY) {
			mainFilters.targetAudiences = state.filters.targetAudiences;
			mainFilters.periods = state.filters.periods;
		} else {
			mainFilters.location = state.filters.location;
			mainFilters.productTypes = state.filters.productTypes;
		}

		return {
			...state,
			filters: {
				...OFFERS_INITIAL_STATE.filters,
				...mainFilters,
			},
		};
	}),
	on(OFFERS_ACTIONS.clearSideFilterValue, (state, obj) => {
		return {
			...state,
			filters: {
				...state.filters,
				[obj.name]: (state.filters as any)[obj.name].filter((item: string) => item !== obj.value),
			},
		};
	}),
	on(OFFERS_ACTIONS.setMaxPrices, (state, obj) => {
		return {
			...state,
			maxPriceAccommodation: obj.maxPriceAccommodation,
			maxPriceDaytrip: obj.maxPriceDaytrip,
		};
	}),

	on(OFFERS_ACTIONS.addOffers, (state, obj) => {
		return {
			...state,
			data: {
				...state.data,
				list: [...state.data.list, ...obj.offers],
				nextAvailable: obj.offers.length >= OFFERS_INITIAL_STATE.data.size,
				page: state.data.page + 1,
				total: obj.total,
			},
		};
	}),
	on(OFFERS_ACTIONS.clearOffers, (state) => {
		return {
			...state,
			data: {
				...OFFERS_INITIAL_STATE.data,
				loading: state.data.loading,
				view: state.data.view,
			},
		};
	}),
	on(OFFERS_ACTIONS.loadingOffers, (state, obj) => {
		return {
			...state,
			data: {
				...state.data,
				loading: obj.loading,
			},
		};
	}),

	on(OFFERS_ACTIONS.setUser, (state, obj) => {
		return {
			...state,
			user: obj.user,
		};
	}),

	on(OFFERS_ACTIONS.setView, (state, obj) => {
		return {
			...state,
			data: {
				...OFFERS_INITIAL_STATE.data,
				view: obj.view,
			},
		};
	}),
	on(OFFERS_ACTIONS.setMap, (state, obj) => {
		return {
			...state,
			map: {
				...obj.options,
			},
		};
	})
);

export function offersReducer(state: any, action: any) {
	return _offersReducer(state, action);
}
